import { render, staticRenderFns } from "./NavbarTopWorkflow.vue?vue&type=template&id=6cfed3ac"
import script from "./NavbarTopWorkflow.vue?vue&type=script&lang=js"
export * from "./NavbarTopWorkflow.vue?vue&type=script&lang=js"
import style0 from "./NavbarTopWorkflow.vue?vue&type=style&index=0&id=6cfed3ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports